import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

export const HomePageBody = (
    props: Immutable<Pick<templates.HomePageTemplate, "page">>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    // The legacy `{% include_block self.body %}` wrapped each top-level body
    // block in `<div class="block-{type}">` (Wagtail's StreamBlock rendering).
    // The home page's page-specific SCSS targets those wrappers -- e.g.
    // `.home-page .block-rich_text` adds 5vw padding (15vw top/bottom on mobile)
    // and `.home-page .block-mega_hero` positions the hero. A bare
    // `<StreamField tagName={Fragment}>` emits the block components WITHOUT those
    // wrappers, dropping that spacing (a ~60px mobile shift). Reproduce one
    // wrapper per top-level block (reusing the type-safe StreamField for a single
    // block). The home and generic pages' SCSS both depend on these wrappers
    // (see `GenericPageBody`, same pattern); the other consolidated
    // page bodies render the bare StreamField.
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{ className: `block-${block.type}` }}
                    value={[block]}
                    components={toolboxComponentsMap}
                />
            ))}
        </>
    );
};
